<style>
  html,
  body {
    padding: 0;
    margin: 0;
    font-family: "Sen", sans-serif;
  }

  pre {
    font-size: small;
  }

  input {
    margin-top: 1em;
  }

  img {
    max-width: 60%;
    margin: 1em;
  }

  div.progress.visible {
    visibility: visible;
  }

  div.progress {
    visibility: hidden;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    background-color: white;
    width: 100%;
    height: 100%;
  }

  div.gradient {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    display: fixed;
    top: 0;
    left: 0;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.32+100 */
    background: -moz-radial-gradient(center, ellipse cover, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%);
    /* FF3.6-15 */
    background: -webkit-radial-gradient(center, ellipse cover, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%);
    /* Chrome10-25,Safari5.1-6 */
    background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%);
    /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#52000000', GradientType=1);
    /* IE6-9 fallback on horizontal gradient */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  div.progress-wrapper {
    font-size: 2em;
    padding: 2em;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 40%;
    border: 2px solid black;
    background: white;
    box-shadow: 0.5em 0.5em 0.5em rgba(0, 0, 0, 0.25);
    border-radius: 0.2em;
  }

  progress {
    width: 100%;
    margin: 0.2em;
  }

  div.wrapper {
    padding: 5px;
  }

  div.wrapper,
  div.wrapper > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  #parsed .error {
    padding: 0px 1em;
    max-width: 60%;
  }

  div#detected {
    margin-bottom: 1em;
    flex-direction: column-reverse;
  }

  canvas {
    max-width: 100%;
    margin: 5px;
  }

  canvas[title="crop"] {
    max-width: 100%;
    margin: 0px 5px;
  }

  @media screen and (orientation: landscape) {
  }

  @media screen and (orientation: portrait) {
  }

  .ant-btn-primary:hover {
    color: #fff;
    background-color: rgb(251 136 0);
    border-color: rgb(251 136 0);
  }

  .ant-btn-primary {
    color: #fff;
    background-color: rgb(246 146 28);
    border-color: rgb(246 146 28);
    text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  }

  .ant-btn-lg {
    height: 40px;
    padding: 0 15px;
    font-size: 16px;
    border-radius: 2px;
  }

  .ant-btn {
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    box-shadow: none;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: manipulation;
    height: 32px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 2px;
    margin: 0 auto 1rem;
    border: 1px;
    outline: 0;
  }

  .wrapper ul {
    /* display: grid; */
    list-style: none;
    grid-template-columns: minmax(25rem, 40rem) 1fr;
    margin: 0;
    padding: 0;
  }

  .base-text {
    font-size: 18px;
    line-height: 2;
    text-align: justify;
    margin-bottom: 0;
  }

  .main-heading {
    display: block;
    height: 50px;
    width: 100%;
    /* margin-bottom: 30px;*/
  }

  .main-heading .upload {
    text-align: center;
    margin: 0 auto;
    left: 0;
    right: 0;
    position: absolute;
    top: 11px;
    width: 200px;
  }

  .main-title {
    font-size: 24px;
    width: 100%;
    font-weight: 700;
    margin-top: 0;
    color: #1c1e1f;
    margin-bottom: 0;
    font-family: "Sen", sans-serif;
    text-align: center;
  }

  .main-title-s {
    font-size: 15px;
    line-height: 2;
    width: 100%;
    font-weight: 700;
    margin-top: 0;
    color: #1c1e1f;
    margin-bottom: 0;
    font-family: "Sen", sans-serif;
  }

  .main-heading div {
    display: inline-block;
    font-size: 13px;
  }

  .main-heading a {
    color: #000;
    font-weight: bold;
    text-decoration: none;
    padding-left: 5px;
    cursor: pointer;
  }

  .main-text p {
    width: 100%;
    font-size: 10px;
    order: 2;
    font-family: "Sen", sans-serif;
    font-weight: 400;
    line-height: 1.6;
    color: #3e4b5b;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .content__column {
    display: flex;
    flex-direction: column;
    max-width: 66rem;
    justify-content: center;
    margin: 0;
    padding: 0 1rem 0;
  }

  .wrapper .border {
    border-right: none;
  }

  .borderb-0 {
    border-bottom: none !important;
  }

  .br-0 {
    border-right: none !important;
  }

  .base-text--bold {
    font-weight: 700;
    font-size: 1.8rem;
    line-height: 2.6rem;
  }

  .images-req-list {
    display: flex;
  }

  .image-requirements {
    margin: 0 auto;
  }

  .img--default {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: auto;
    max-width: 100%;
    margin: 0;
  }

  input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
  }

  .bt-0 {
    border-top: 0 !important;
  }

  .box {
    max-width: 250px;
  }

  p {
    margin-bottom: 0;
  }

  .popup {
    width: 900px;
    margin: auto;
    text-align: center;
  }

  .popup img {
    width: 217px;
    cursor: pointer;
  }

  .show {
    z-index: 999;
    display: none;
    background: rgb(0 0 0 / 50%);
  }

  .show .overlay {
    width: 100%;
    height: 100%;
    background: rgb(0 0 0 / 7%);
    position: absolute;
    top: 0;
    left: 0;
  }

  .show .img-show {
    width: 600px;
    height: 220px;
    background: #fff;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .img-show span {
    position: absolute;
    top: 10px;
    right: 7px;
    z-index: 99;
    cursor: pointer;
  }

  .img-show img {
    width: 94%;
    /* height: 100%; */
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100%;
  }
  .clickable-container {
    border-radius: 10px;
    /* box-shadow: 0 0 10px 0px #e3e3e3; */
    padding: 10px;
    cursor: pointer;
    /* transition: box-shadow 0.3s ease-in-out; */
    position: relative;
  }
  .clickable-container:hover {
    box-shadow: 0 0 10px 0px #161616;
  }
  .clickable-container::before {
    content: "";
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.7);
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.5s;
  }
  .clickable-container:hover::before {
    opacity: 0.5;
  }
  .upload-icon{
    position: absolute;
    top : 50%;
    left : 50%;
    transform: translate(-50%, -50%);
    font-size: 50px;
    color: #ffffff;
    z-index: 1;
    opacity: 0;
  }
  .clickable-container:hover .upload-icon {
    opacity: 1;
  }

  @media screen and (max-width: 768px) {
    .images-req-list {
      display: flex;
      flex-direction: column;
    }

    
  }
  /*End style*/
</style>
<div class="wrapper" [class] = "className">
  <div class="upload-icon">
    <i class="fa-solid fa-upload"></i>
  </div>
  <div class="image-requirements">
    <!-- <div class="main-heading"> -->
      <!-- <h1 class="main-title">Pasaport Resim Yükleme</h1> -->
      <!-- <div>
              <input type="checkbox" id="checkContrat" onchange="checkContratClicked()">
              <a id="elm1" data-bs-toggle="modal" data-bs-target="#exampleModal">Okudum, Onaylıyorum.</a>
          </div> -->
      <!-- <div class="upload">
        <p>
          <button id="ocrButton" style="display: none" onclick="clickBrowse()" type="button" class="download ant-btn ant-btn-primary ant-btn-lg ant-btn-block">
            <i aria-label="icon: upload" class="anticon anticon-upload">
              <svg viewBox="64 64 896 896" data-icon="upload" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="">
                <path
                  d="M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                ></path>
              </svg>
            </i>
            <span id="elm2">Pasaport Resmi Yükle</span> <span id="elm3">(jpg, png dosyaları kabul edilir.)</span>
          </button>
        </p>
      </div> -->
    <!-- </div> -->

    <div class="images-req-list">
      <ul class="box border borderb-0 br-0">
        <li class="content__column">
          <h1 id="elm25" class="main-title-s">Aydınlık</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/aydinlik.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm4">Görüntü çok karanlık veya çok parlak olduğunda belge doğrulanamaz.</p>
          </div>
        </li>
      </ul>
      <ul class="box border borderb-0 br-0">
        <li class="content__column">
          <h1 id="elm5" class="main-title-s" id="elm5">Yansıma</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/yansima.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm6">Görüntü üzerindeki yansımalar, verilerin işlenmesine ve çıkarılmasına müdahale eder.</p>
          </div>
        </li>
      </ul>
      <ul class="box border borderb-0">
        <li class="content__column">
          <h1 id="elm7" class="main-title-s">Odak ve keskinlik</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/odak-ve-keskinlik.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm8">Görüntünün net olduğundan ve bulanık alan olmadığından emin olun.</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- ikinci resim -->
  <div class="image-requirements">
    <div class="images-req-list bt-0">
      <ul class="box border borderb-0 br-0">
        <li class="content__column">
          <h1 class="main-title-s" id="elm9">Açı</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/aci.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm10">Belgenin eğim açısı hiçbir yönde (yatay veya dikey) 10 dereceyi geçmemelidir.</p>
          </div>
        </li>
      </ul>
      <ul class="box border borderb-0 br-0">
        <li class="content__column">
          <h1 id="elm11" class="main-title-s">Kenar boşluğu(yakın)</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/kenar-boslugu-yakin.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm12">Görüntüyü yakınlaştırmayın. Belgenin görüntünün %70-80'ini kaplaması önerilir.</p>
          </div>
        </li>
      </ul>
      <ul class="box border borderb-0">
        <li class="content__column">
          <h1 id="elm13" class="main-title-s">Kenar Boşluğu(uzak)</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/kenar-boslugu-uzak.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm14">Belgenin etrafındaki boşluğun görüntünün %20-30'undan fazlasını kaplamadığından emin olun.</p>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Üçüncü Resim -->

  <div class="image-requirements">
    <div class="images-req-list bt-0">
      <ul class="box border br-0">
        <li class="content__column">
          <h1 class="main-title-s" id="elm15">Zıtlık</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/zitlik.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm16">Açık renkli arka plan üzerinde açık renkli belge veya koyu arka plan üzerinde koyu renkli belge tanınamaz.</p>
          </div>
        </li>
      </ul>
      <ul class="box border br-0">
        <li class="content__column">
          <h1 id="elm17" class="main-title-s">Çözünürlük</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/cozunurluk.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm18">Kamera ile çekilmiş görüntüleri en az Full HD (1920×1080) çözünürlükte ve otomatik odaklamalı olarak sağlamanızı öneririz.</p>
          </div>
        </li>
      </ul>
      <ul class="box border">
        <li class="content__column">
          <h1 id="elm19" class="main-title-s">Temassızlık</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/Temassızlık.png" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm20">Elinizin veya diğer nesnelerin belge verilerini kapatmadığından emin olun.</p>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!--dördüncü Bölüm-->

  <div class="image-requirements">
    <div class="images-req-list bt-0">
      <ul class="box border bt-0">
        <li class="content__column">
          <h1 id="elm21" class="main-title-s">Geçerli Sayfa</h1>
          <picture class="img--default popup">
            <img src="/assets/images/mrz/yon.jpeg" alt="" class="img--default" />
          </picture>
          <div class="show">
            <div class="overlay"></div>
            <div class="img-show">
              <span>X</span>
              <img src="" />
            </div>
          </div>
          <div class="main-text">
            <p id="elm22">Pasaportun sadece ilk sayfasının, kişi bilgilerinin bulunduğu sayfanın, görüntüsü sisteme yüklenmelidir.</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="input">
    <input style="display: none" type="file" id="photo" name="photo" accept="image/png, image/jpeg" />
  </div>
</div>
